export const ACTION_CODE = 'PAYMENT' + '_METHOD' + '_ACTION';
